(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mini-before-after"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mini-before-after')) {
    customElements.define('mini-before-after', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const range = this.querySelector('input[type="range"]');
        if (!range) return;
        const update = () => this.style.setProperty('--comparison-position', `${range.value}%`);
        const move = event => {
          const bounds = this.getBoundingClientRect();
          if (!bounds.width) return;
          range.value = String(Math.round(Math.max(0, Math.min(100, (event.clientX - bounds.left) / bounds.width * 100))));
          update();
        };
        range.addEventListener('input', update, options);
        range.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.button !== 0) return;
          event.preventDefault();
          this.pointer = event.pointerId;
          range.focus({ preventScroll: true });
          range.setPointerCapture(event.pointerId);
          move(event);
        }, options);
        range.addEventListener('pointermove', event => {
          if (event.pointerId === this.pointer) move(event);
        }, options);
        const end = event => {
          if (event.pointerId !== this.pointer) return;
          this.pointer = null;
          if (range.hasPointerCapture(event.pointerId)) range.releasePointerCapture(event.pointerId);
        };
        range.addEventListener('pointerup', end, options);
        range.addEventListener('pointercancel', end, options);
        range.addEventListener('lostpointercapture', end, options);
        update();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.pointer = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
